import { useState } from 'react';
import { Box, Button } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import StyledDataGrid from '../../../components/StyledDataGrid';
import WorkspacePage from '../../../components/WorkspacePage';

const BioBankProjectSpecimen = () => {
  const [rows] = useState([
    { id: 1, projectSpecimenID: 'PS001', projectID: 'P001', bioSpecimenID: 'B001', specimenData: 'Data A', authorization: 'Approved', userName: 'User A', providerName: 'Provider A', completionReason: 'Completed' },
    { id: 2, projectSpecimenID: 'PS002', projectID: 'P002', bioSpecimenID: 'B002', specimenData: 'Data B', authorization: 'Pending', userName: 'User B', providerName: 'Provider B', completionReason: 'Ongoing' },
  ]);

  const columns = [
    { field: 'projectSpecimenID', headerName: 'Project Specimen ID', flex: 1 },
    { field: 'projectID', headerName: 'Project ID', flex: 1 },
    { field: 'bioSpecimenID', headerName: 'BioSpecimen ID', flex: 1 },
    { field: 'specimenData', headerName: 'Specimen Provided Data', flex: 2 },
    { field: 'authorization', headerName: 'Authorization', flex: 1 },
    { field: 'userName', headerName: 'User Name', flex: 1 },
    { field: 'providerName', headerName: 'Provider Name', flex: 1 },
    { field: 'completionReason', headerName: 'Completion Reason', flex: 1 },
  ];

  return (
    <WorkspacePage>
      <PageHeader
        title="BioBank Project Specimen"
        actions={<Button variant="outlined">Add Data</Button>}
      />
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', overflowX: 'auto' }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination
          autoHeight
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f5f5f5' },
          }}
        />
      </Box>
    </WorkspacePage>
  );
};

export default BioBankProjectSpecimen;
